module.exports = __webpack_public_path__ + "img/gb-languages.bd766b50.png";